import { type ClientHeatmapReport } from '@/features/reports/api';
import { HEATMAP_COPY as COPY } from '@/features/reports/copy';
import { type EngagementSignal, type HeatmapWeeks, QUIET_SIGNALS } from '@/features/reports/tabs';

/** Falling engagement is the one a stylist should act on, so only it gets the warm tone. */
export const signalVariant = (signal: EngagementSignal): 'warning' | 'secondary' =>
    QUIET_SIGNALS.includes(signal) ? 'warning' : 'secondary';

/** "W29 to W34", the weeks on screen; null when the log holds none of them. */
export function weekRange(report: ClientHeatmapReport): string | null {
    const first = report.columns[0];
    const last = report.columns.at(-1);
    return first && last ? COPY.range(first.label, last.label) : null;
}

/** The window's hint, naming the actual weeks so "4 weeks" is never unclear about which four. */
export function heatmapHint(report: ClientHeatmapReport): string {
    const first = report.columns[0];
    const last = report.columns.at(-1);
    return first && last
        ? COPY.hint(first.label, last.label, report.columns.length)
        : COPY.nothingLogged;
}

/** The file the export downloads as, named as the API names it. */
export function heatmapFileName(weeks: HeatmapWeeks): string {
    const day = new Date().toISOString().slice(0, 10);
    return `a-list-client-heatmap-log-${weeks}-weeks-${day}.xlsx`;
}
